import { Link } from "react-router-dom";
import styled from "styled-components";

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DivisionChangeName = styled.div`
  width: 100%;
  margin: 0rem 3rem 0 0;

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    margin: 0rem;
    background-color: white;
  }

  h3 {
    font-size: 1.1rem;
    color: #808080;
  }

  label {
    font-size: 1rem;
    color: #808080;
    margin-bottom: 0.2rem;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.8rem;
  }
`;

export const DivisionButton = styled.div`
  margin: 2rem 0 0 0rem;
  width: 20%;

  @media(max-width: 1700px) {
    width: 30%;
  }

  @media(max-width: 1400px) {
    width: 40%;
  }

  @media(max-width: 920px) {
    width: 50%;
  }

  @media(max-width: 770px) {
    margin: 2rem 0 0 0rem;
    width: 100%;
  }
`;

export const InsertName = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem 0 2rem 0rem;
  width: 20%;

  @media(max-width: 1700px) {
    width: 30%;
  }

  @media(max-width: 1400px) {
    width: 40%;
  }

  @media(max-width: 920px) {
    width: 50%;
  }

  @media(max-width: 770px) {
    margin: 0rem 0 2 0rem;
    width: 100%;
  }

  input {
    border: 1px solid #b0b0b0;

    @media(max-width: 770px) {
      font-size: .85rem;
    }
  }
`;

export const CaptchaArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;

  @media(max-width: 1700px) {
    width: 30%;
  }

  @media(max-width: 1400px) {
    width: 40%;
  }

  @media(max-width: 920px) {
    width: 50%;
  }

  @media(max-width: 770px) {
    width: 100%;
  }
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: -1rem 5rem 1.5rem 0;
  cursor: pointer;

  @media (max-width: 1366px) {
    margin: 0 5rem 0 0;
  }

  @media (max-width: 770px) {
    margin: -2rem 1rem 0.3rem 0;
  }
`;


export const Content = styled.div`
  padding: 0.5rem 2rem 2rem 2rem;
  margin: 0 0 0 3rem;

  @media(max-width: 770px) {
    margin: 0;
  }
`;

export const IconLoading = styled.i`
  font-size: 1.5rem;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const HeaderMobileContainer = styled.div`
  width: 100%;
  background-color: white;

  @media (min-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 1rem 0 0rem 0rem;

  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-left: 0px;
    margin: 3rem 0 2rem 0rem;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const ModalErrorMessage = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #707070;
`;
